import React, { useState, useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import { lightTheme } from "../../SharedComponents/SharedComponentStyles";
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { createMuiTheme, ThemeProvider } from "@material-ui/core";
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import * as XLSX from "xlsx";
import axios from 'axios'
import Alert from '@material-ui/lab/Alert';
//import Loader from '../../pages/Loading';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useSelector, useDispatch } from "react-redux";

const api = axios.create({
    baseURL: 'MasterDetails'
})

function UploadSapData(props) { 
    const [data, setData] = useState([]); //table data
    //for error handling
    const [iserror, setIserror] = useState(false);
    const [errorMessages, setErrorMessages] = useState([]);
    const [validationSValueMsg, setvalidationSValueMsg] = useState([]);
    //file saving
    var selectedFile = null;
    var validateFileFormat = null;
    const [open, setopen] = useState('');
    const [openAlert, setopenAlert] = useState('');
    const [openClassName, setopenClassName] = useState('');
    const [openType, setopenType] = useState('');
    const [fileValue, setfileValue] = useState('');
    const [openLoader, setopenLoader] = useState(false);

    const [CreatedUserId, setCreatedUserId] = useState(props.loginuser.response.employeeId);

    //for alert
    const [alertsuccess, setalertsuccess] = useState("Success");
    const [alerterror, setalerterror] = useState("Alert");
    const [alertsuccessclass, setalertsuccessclass] = useState("bg-light-green clr-white");
    const [alerterrorclass, setalerterrorclass] = useState("bg-red clr-white");
    const token = useSelector((state) => state.saveAzureTokenReducer.token);
    const userDetails = useSelector(
    (state) => state.storeUserDetailsReducer.userData);
    const bearerToken = useSelector(
    (state) => state.saveBearerTokenReducer.bearerToken);
    const uId = useSelector((state) => state.saveUIDReducer.uid);
    

    function showMsg(popen, popenAlert, popenClassName, popenType) {
        setopen(popen);
        setopenAlert(popenAlert);
        setopenClassName(popenClassName);
        setopenType(popenType);
    }

    function handleClose() {
        setopen(false);
    }

    function filePathset_Value(e) {
        e.stopPropagation();
        e.preventDefault();
        var valuetemplatefile = e.target.files[0];
        var elementSAP = document.getElementById("SAPFile");
        var element1SAP = elementSAP.parentElement.parentElement;
        selectedFile = e.target.files[0];
        element1SAP.classList.remove("udi-error");
        if (valuetemplatefile !== undefined) {
            var extension = valuetemplatefile.name.split('.')[valuetemplatefile.name.split('.').length - 1];
            if (extension.toString().toUpperCase() === 'XLSX') {
                setfileValue(valuetemplatefile);
            }
            else {
                setfileValue(null);
                document.getElementById('SAPFile').value = null;
                showMsg(true, "Upload Excel file only.", alerterrorclass, alerterror);
            }
        }
    }

    const handleErrorClose = (e) => {
        setIserror(false);
    }

    function submitData() {
        setopenLoader(true);
       // document.getElementById("loadingIcon").style.display = "block";
        UploadSAPDocuments();
    }

   function submitValueDetails() {
        if (isValid()) {
            var f = fileValue;
            const reader = new FileReader();
            reader.onload = (evt) => {
                const bstr = evt.target.result;
                const wb = XLSX.read(bstr, {
                    type: "binary", cellDates: true,
                    cellNF: false,
                    cellText: false
                });

                let rowObject;
                var name_worksheet = wb.SheetNames[0];
                if (name_worksheet != "") {
                    var ws = wb.Sheets[name_worksheet];                
                    rowObject = XLSX.utils.sheet_to_json(ws, { header: 1 });
                    if (rowObject.length > 0) {
                        convertToJsonArray_ValueTemplate(rowObject);
                    }
                    else {
                        showMsg(true, "Excel file is empty. Please upload valid file.", alerterrorclass, alerterror);
                        document.getElementById('file').value = null;
                        this.setState({ valuetemplatefile: null });
                        setopenLoader(false);
                    }
                }
                else {
                    showMsg(true, "Upload Excel valid file.", alerterrorclass, alerterror);
                    // document.getElementById('file').value = null;
                    setfileValue(null);
                    setopenLoader(false);
                }
            };
            reader.readAsBinaryString(f);
        }
    }

    function isValid() {
        if (fileValue === undefined || fileValue === null) {
            showMsg(true, "Please select template file to upload.", alerterrorclass, alerterror);
            setopenLoader(false);
            return false;
        }    
        else
            return true;
    }

    function submitDatacall(e) {
        setvalidationSValueMsg([]);      
        submitData();
        submitValueDetails();      
    }

    function ImportSapData(e) {
        //setopenLoader(true);            
        //api.post("/ImportSapData/")
        //    .then(res => {                
        //        setopenLoader(false);    
        //        showMsg(true, "Data imported successfully.", alertsuccessclass, alertsuccess);
        //    })
        //    .catch(error => {
        //        showMsg(true, "Something went wrong.", alerterrorclass, alerterror);
        //        console.log(error);
        //    })
    }

   function UploadSAPDocuments() {
        const formData = new FormData();
        if (fileValue == null || fileValue == "") {
            document.getElementById("SAPFile").value = "";
            var element = document.getElementById("SAPFile");
            var element1 = element.parentElement.parentElement;
            var element2 = element.parentElement;
            element1.classList.add("udi-error");
            element2.classList.add("Mui-error");
        }
        else {
            if (!isValid()) {
                var element = document.getElementById("SAPFile");
                var element1 = element.parentElement.parentElement;
                var element2 = element.parentElement;
                element1.classList.add("udi-error");
                element2.classList.add("Mui-error");
                document.getElementById("UploadSAPFileFormatError").style.display = "block";
              //  e.preventDefault();
                return false;
            }
         
            document.getElementById("UploadSAPFileFormatError").style.display = "none";
            formData.append('SAPDocument', fileValue);
            const requestOptions = {
                method: 'POST',
                body: formData
            };
            fetch('MasterDetails/UploadSapData', requestOptions)
                .then(async response => {
                    const data = await response.json();
                    if (data === false) {                    
                        document.getElementById("SAPFile").value = "";
                        selectedFile = "";
                        var element = document.getElementById("SAPFile");
                        var element1 = element.parentElement.parentElement;
                        var element2 = element.parentElement;
                        element1.classList.add("udi-error");
                        element2.classList.add("Mui-error");
                        document.getElementById("UploadSAPError").style.display = "block";
                    }
                    else {
                        document.getElementById("SAPFile").value = "";
                        selectedFile = "";                     
                        document.getElementById("UploadSAPSuccess").style.display = "block";                     
                    }
                })
                .catch(error => {                   
                    document.getElementById("SAPFile").value = "";
                    selectedFile = "";
                    document.getElementById("UploadSAPError").style.display = "block";                   
                });
        }
    }

   const convertToJsonArray_ValueTemplate=(rowObject)=> {
        let arrMstExp = [];
        rowObject.forEach(item => {
            arrMstExp.push({
                "Material": (item[0] === undefined) ? "" : item[0].toString(),
                "MaterialDescription": (item[1] === undefined) ? "" : item[1].toString(),
                "OpAc": (item[2] === undefined) ? "" : item[2].toString(),
                "WorkCtr": (item[3] === undefined) ? "" : item[3].toString(),
                "MachineSetuptime": (item[4] === undefined) ? 0 : parseFloat(item[4]),
                "Unit": (item[5] === undefined) ? "" : item[5].toString(),
                "MachineRuntime": (item[6] === undefined) ? 0 : parseFloat(item[6]),
                "Mrtunit": (item[7] === undefined) ? "" : item[7].toString(),
                "Laboursetuptime": (item[8] === undefined) ? 0 : parseFloat(item[8]),
                "Lstunit": (item[9] === undefined) ? "" : item[9].toString(),
                "Labourruntime": (item[10] === undefined) ? 0 : parseFloat(item[10]),
                "Lrtunit": (item[11] === undefined) ? "" : item[11].toString(),
                "OperationDesc": (item[12] === undefined) ? "" : item[12].toString(),
                "OperationSplit": (item[13] === undefined) ? "": item[13].toString(),
                "CtrK": (item[14] === undefined) ? "" : item[14].toString(),
                "SalesDoc": (item[15] === undefined) ? "" : item[15].toString(),
                "Item": (item[16] === undefined) ? "" : item[16].toString(),
                "Group": (item[17] === undefined) ? "" : item[17].toString(),
                "GrC": (item[18] === undefined) ? "" : item[18].toString(),
                "RelevancytoCostingIndicator": (item[19] === undefined) ? "" : item[19].toString(),
                "Status": (item[20] === undefined) ? 0 : parseFloat(item[20]),
                "MrpController": (item[21] === undefined) ? "" : item[21].toString(),
                "WageGroup": (item[22] === undefined) ? 0 : parseFloat(item[22]),
                "GroupCounterdescription": (item[23] === undefined) ? "" : item[23].toString(),
                "WorkcenterDesciption": (item[24] === undefined) ? "" : item[24].toString(),
                "BaseQuantity": (item[24] === undefined) ? 0 : parseFloat(item[24]),
                "IsActive": 1,
                "CreatedBy": CreatedUserId,
                "ModifiedBy": CreatedUserId
            })
        })     
       saveValueToDB(arrMstExp);
    }

    function saveValueToDB(arrMstExp) {
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        const options = {
            method: 'post',
            headers: {
                'Accept': 'application/json, text/plain, */*',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(arrMstExp)
        }
        fetch('MasterDetails/PostSAPData', options,{
            headers: headers
        })
            .then(response => response.json())
            .then((result) => {
               // console.log('Success:', result);
                if (result > 0) {
                    setvalidationSValueMsg(result);
                    //alert("Data added successfully!");
                    showMsg(true, "Data saved successfully!", alertsuccessclass, alertsuccess);
                    setopenLoader(false);

                    document.getElementById("UploadSAPSuccess").style.display = "block";                   
                }
                else {
                    if (result <= 0) {                        
                        showMsg(true, "Something went wrong!", alerterrorclass, alerterror);
                        setopenLoader(false);
                        setvalidationSValueMsg([]);
                    }
                    else {
                        document.getElementById("UploadSAPSuccess").style.display = "block";
                        setvalidationSValueMsg([]);
                    }
                }
                document.getElementById('file').value = null;
                setfileValue(null);               
            })
            .catch((error) => {
                console.log("Error:", error);
                setopenLoader(false);
            });
    }

    useEffect(() => {
        setopenLoader(false);
    }, []) 

    return (
        <ThemeProvider theme={lightTheme}>
            <div className="master-layout-data">
                <Box paddingTop={{ xs: '5rem', sm: '2rem' }} className="">
                    <h3 className="clr-dark-blue d-flex jc-center mt-2 mb-1">Upload Sap Data</h3>
                </Box>
                <Grid container spacing={1} className="d-flex jc-center mb-2 bdr-radius">
                    <Grid item xs={12} sm={11} className="userManagement mt-1 mb-1">
                        <div className="width-100">
                            <form noValidate autoComplete="off">
                                <TextField
                                    type="file"
                                    id="SAPFile"
                                    className="upload-document-input"
                                    label="Upload SAP "
                                    fullWidth
                                    onChange={(e) => filePathset_Value(e)}
                                   
                                />
                                <Typography id="UploadSAPSuccess" className="clr-light-green fw-bold f-14" hidden>File Uploaded Successfully</Typography>
                                <Typography id="UploadSAPFileFormatError" className="clr-red fw-bold f-12" hidden>File format must be Excel only</Typography>
                                <Typography id="UploadSAPFileSizeError" className="clr-red fw-bold f-12" hidden>File must be less than 5MB</Typography>
                                <Typography id="UploadChooseSAPFileError" className="clr-red fw-bold f-12" hidden>Please Choose File</Typography>
                                <Typography id="UploadSAPError" className="clr-red fw-bold f-12" hidden>Error while uploading file</Typography>
                            </form>
                          <div id="invalidMessages">
                               
                            </div>
                        </div>
                        <div className="width-100 mt-1">
                            <div className="d-flex">
                                <Button variant="contained" className="ns-btn-secondary-light" onClick={(e) => submitDatacall(e)}>
                                    <span className="f-14 fw-500">Submit</span>
                                </Button>
                                <Button variant="contained" className="ml-2 ns-btn-secondary-light" onClick={(e) => ImportSapData(e)}>
                                    <span className="f-14 fw-500">SAP Import From Shared Location</span>
                                </Button>
                            </div>
                        </div>
                        
                        <div>
                            {iserror &&
                                <Alert severity="error" onClose={handleErrorClose}>
                                    {errorMessages.map((msg, i) => {
                                        return <div key={i}>{msg}</div>
                                    })}
                                </Alert>
                            }
                        </div>
                        <Dialog
                            open={openLoader}
                            //onClose={handleClose}
                            aria-labelledby="draggable-dialog-title"
                            id="templateUploadSuccess"
                            PaperProps={{
                                style: {
                                    backgroundColor: "transparent",
                                    boxShadow: "none",
                                    borderColor: "transparent"
                                },
                            }}>
                            <DialogContent>
                                <CircularProgress />
                            </DialogContent>
                        </Dialog>
                      
                    </Grid>
                </Grid>
                <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="draggable-dialog-title"
                    id="templateUploadSuccess">
                    <DialogTitle className={openClassName} style={{ cursor: 'move' }} id="draggable-dialog-title">
                        {openType}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText className="clr-black">
                            {openAlert}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" autoFocus onClick={handleClose} className="ns-btn-secondary-light">
                            <span className="f-16 fw-bold">OK</span>
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
           
        </ThemeProvider>
    );
}

export default UploadSapData;